import { SDK_Colors, SDK_Fonts } from "@quickpoint.me/shared";
import { FilterInterface } from "../@types/viewerati";

let fonts: SDK_Fonts;

function interpolateFonts(filter: FilterInterface): FilterInterface {
  if (!filter) return filter;
  if (filter.fonts) fonts = filter.fonts;

  for (const [key, value] of Object.entries(filter)) {
    const v = value as keyof SDK_Colors;
    const k = key as keyof FilterInterface;

    if (k === "font") {
      //@ts-expect-error: must try harder.
      filter[k] = fonts[v];
    }
  }

  return filter;
}

export default interpolateFonts;
